/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SourcingSearchMatchingSkillOrigin = {
    Explicit: 'EXPLICIT',
    Deducted: 'DEDUCTED'
} as const;
export type SourcingSearchMatchingSkillOrigin = typeof SourcingSearchMatchingSkillOrigin[keyof typeof SourcingSearchMatchingSkillOrigin];


export function instanceOfSourcingSearchMatchingSkillOrigin(value: any): boolean {
    for (const key in SourcingSearchMatchingSkillOrigin) {
        if (Object.prototype.hasOwnProperty.call(SourcingSearchMatchingSkillOrigin, key)) {
            // @ts-ignore
            if (SourcingSearchMatchingSkillOrigin[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SourcingSearchMatchingSkillOriginFromJSON(json: any): SourcingSearchMatchingSkillOrigin {
    return SourcingSearchMatchingSkillOriginFromJSONTyped(json, false);
}

export function SourcingSearchMatchingSkillOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchMatchingSkillOrigin {
    return json as SourcingSearchMatchingSkillOrigin;
}

export function SourcingSearchMatchingSkillOriginToJSON(value?: SourcingSearchMatchingSkillOrigin | null): any {
    return value as any;
}

